import type { Message, ForwardMediaSource } from '../services/api';
import { messageCopyText } from './messageCopy';

/** D-883: original readable text from either member of this conversation.
 * Destination selection only creates a draft; never forward translations,
 * attachments, expired/withdrawn text or unreadable ciphertext envelopes. */
export function forwardText(message: Message | undefined, myId: number, otherId: number): string | null {
  if (!message || ![myId, otherId].includes(message.sender_id)) return null;
  return messageCopyText(message);
}
export function forwardMediaSource(message:Message|undefined,myId:number,otherId:number):ForwardMediaSource|null {
  if(!message||![myId,otherId].includes(message.sender_id)||!['pending','sent','replied'].includes(message.status)
    ||!['image','video','voice'].includes(message.type))return null;
  return {sourceId:message.id,sourceRevision:message.edit_revision??0,kind:message.type as ForwardMediaSource['kind']};
}
